import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./custom_carousel_style.css";

export default function CarouselLevelImages(props) {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  return(
    <Carousel
      swipeable={true}
      draggable={true}
      responsive={responsive}
      // ssr={true} // means to render carousel on server-side.
      infinite={true}
      autoPlay={false}
      // autoPlaySpeed={5000}
      keyBoardControl={true}
      containerClass="carousel-container"
      removeArrowOnDeviceType={["tablet", "mobile"]}
      showDots={true}
      // dotListClass="custom-dot-list-style"
      itemClass="carousel-item-padding-40-px">
      {
        props.images.map((image, key) => {
          return(
            <div key={key}>
              <img
                src={image}
                alt="level_image"
                className="card-img img-scale main-image"
              />
            </div>
          )
        })
      }
    </Carousel>
  );
}
